import { es } from '../i18n/es.js';

export function LoadingScreen() {
  return (
    <main
      role="status"
      aria-live="polite"
      className="flex min-h-dvh items-center justify-center bg-surface px-6 text-neutral-500"
    >
      <span className="inline-flex items-center gap-3 text-sm">
        <span
          aria-hidden="true"
          className="size-4 animate-spin rounded-full border-2 border-neutral-300 border-t-accent dark:border-neutral-700 dark:border-t-accent"
        />
        {es.loading}
      </span>
    </main>
  );
}
